import React from "react";
import { Typography, Box, Switch, makeStyles } from "@material-ui/core";
import LockIcon from "@material-ui/icons/Lock";
import WarningIcon from "@material-ui/icons/Warning";
import { useCommissionContext } from "../../../../contexts/CommissionContext";

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(3),
    width: "100%",
  },
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  content: {
    marginBottom: theme.spacing(3),
  },
  controls: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  switchLabel: {
    display: "flex",
    alignItems: "center",
  },
  statusLabel: {
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1, 2),
    backgroundColor: theme.palette.grey[200],
    display: "flex",
    alignItems: "center",
  },
  activatedStatus: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
  },
  warningIcon: {
    marginRight: theme.spacing(1),
  },
}));

/**
 *
 */
export default function CommissionFreezeControl() {
  const classes = useStyles();
  const { updateFreeze, handleToggleFreeze } = useCommissionContext();

  return (
    <Box className={classes.container}>
      <Box className={classes.content}>
        <Box className={classes.iconWrapper}>
          <LockIcon style={{ marginRight: 8 }} />
          <Typography variant="h6">Commission Freeze Control</Typography>
        </Box>
        <Typography variant="body2" color="textSecondary">
          During commission periods, some user profile updates are temporarily
          frozen. This control is independent from the main commission workflow.
        </Typography>
      </Box>

      <Box className={classes.controls}>
        <Box className={classes.switchLabel}>
          <Typography variant="body2">Activate Commission Freeze</Typography>
          <Switch
            checked={updateFreeze}
            onChange={() => handleToggleFreeze()}
            color="primary"
          />
        </Box>
        <Typography
          variant="body2"
          className={`${classes.statusLabel} ${
            updateFreeze ? classes.activatedStatus : ""
          }`}
          onClick={handleToggleFreeze}
          style={{ cursor: "pointer" }}
        >
          {updateFreeze ? (
            <>
              <WarningIcon className={classes.warningIcon} fontSize="small" />
              Active
            </>
          ) : (
            "Inactive"
          )}
        </Typography>
      </Box>
    </Box>
  );
}
